import type { ComponentProps, ReactNode } from "react";
import { Link } from "@tanstack/react-router";
import { EmptyState } from "./EmptyState";

/** A fixed toolbar keeps every project collection on the same content baseline. */
export function ProjectToolbar({ children, right }: { children: ReactNode; right?: ReactNode }) {
  return <div className="project-toolbar flex h-12 shrink-0 items-center gap-4 border-b border-border px-6">
    <div className="flex min-w-0 items-center gap-1 overflow-x-auto">{children}</div>
    {right && <div className="ml-auto flex shrink-0 items-center gap-2">{right}</div>}
  </div>;
}

export function ProjectStatusTabs({ ws, projectKey, kind, tabs, selected, label }: {
  ws: string; projectKey: string; kind: "tasks" | "issues"; selected: string;
  tabs: readonly { id: string; label: string }[]; label: string;
}) {
  return <nav className="flex items-center gap-1" aria-label={label}>
    {tabs.map((tab) => <Link key={tab.id}
      to={kind === "tasks" ? "/$ws/project/$key/tasks/$tab" : "/$ws/project/$key/issues/$tab"}
      params={{ ws, key: projectKey, tab: tab.id }}
      aria-current={selected === tab.id ? "page" : undefined}
      className={`inline-flex h-8 shrink-0 items-center justify-center whitespace-nowrap rounded-full px-3 text-[13px] font-medium transition-colors ${selected === tab.id ? "bg-active text-fg" : "text-muted hover:bg-hover hover:text-fg"}`}>
      {tab.label}
    </Link>)}
  </nav>;
}

export function ProjectEmptyState(props: ComponentProps<typeof EmptyState>) {
  return <div className="project-empty flex min-h-0 flex-1 overflow-y-auto px-6 py-10">
    <div className="m-auto w-full [&>div]:py-0 [&_p]:min-h-[49px] [&_p]:leading-[1.75] [&_h2]:leading-7">
      <EmptyState {...props} />
    </div>
  </div>;
}
